export const CATEGORIES = {
    GIFTBOX: 1,
    GIFTCARD: 2,
    COMBOBOX: 3,
    DONATIONS: 4
}